import { AllNafResponse } from '../../../types/api/endpoints/consultations/allNAF.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[allActiveNAFQuery]';

export const queryAllActiveNAF = async () => {
  console.log(PREFIX, `Fetching all NAF...`);
  const response = await CONSULTATIONS_ENDPOINTS.allActiveNaf();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all NAF.`);
  return json as AllNafResponse;
};
